import { ofType } from "redux-observable";
import { catchError, mergeMap, map } from "rxjs/operators";
import { of } from "rxjs";

import * as actions from "../actionTypes";
import { FetchRX } from "../../helpers/misc";

export const getFeatures = (action$) =>
  action$.pipe(
    ofType(actions.GET_FEATURES),
    mergeMap(() =>
      FetchRX(`/features`).pipe(
        map((result) => {
          return {
            type: actions.GET_FEATURES_SUCCEED,
            payload: result.features,
          };
        }),
        catchError((error) => {
          return of({ type: actions.GET_FEATURES_FAILED });
        })
      )
    )
  );
